import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

const Header = ({ toggleSidebar }) => {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Get user initials for avatar
  const getInitials = () => {
    if (!usuario) return 'U';
    const first = usuario.first_name ? usuario.first_name.charAt(0) : '';
    const last = usuario.last_name ? usuario.last_name.charAt(0) : '';
    return `${first}${last}`.toUpperCase() || 'U';
  };

  return (
    <header className="header">
      {/* Zona Izquierda: Toggle + Logo Ministerio */}
      <div className="header-left">
        <button className="sidebar-toggle" onClick={toggleSidebar} title="Alternar menú">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
        <img src="/Logo_ministerio.png" alt="Ministerio de las Aguas" className="logo-ministerio" />
      </div>

      {/* Zona Derecha: Logo HIDROVEN + Perfil */}
      <div className="header-right">
        <button className="theme-toggle" onClick={toggleTheme} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
          {theme === 'dark' ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
          )}
        </button>

        <img src="/custom_logo_right.png" alt="Hidroven" className="logo-hidroven" />
        
        <div className="header-divider"></div>
        
        <div className="user-profile">
          <div className="user-info-text">
            <span className="user-name">{usuario?.first_name} {usuario?.last_name}</span>
            <span className="user-role-pill">{usuario?.role_display}</span>
          </div>
          <div className="avatar-wrapper">
            <div className="user-avatar">{getInitials()}</div>
            <div className="online-indicator"></div>
          </div>
        </div>

        <button className="btn-logout" onClick={handleLogout} title="Cerrar sesión">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span className="logout-text">Salir</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
